import { IconButton as _IconButton, styled } from '@mui/material';

export const IconButton = styled(_IconButton)({ alignSelf: 'flex-start' });
export const Div = styled('div')({});
